module.exports = __webpack_public_path__ + "static/media/bag.77e269a1.svg";